// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"856":"410a7253","935":"6eeb64d6"}[chunkId] + ".js";
};